import { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { STORE_NAME } from "@/lib/pizzeria";

const TARGETS = [["menu", "Menu"], ["home", "Pagina principale"]];

export default function QrPage() {
  const [target, setTarget] = useState("menu");
  const [table, setTable] = useState("");
  const ref = useRef(null);
  const base = window.location.origin + (target === "menu" ? "/menu" : "/");
  const url = table ? `${base}?tavolo=${encodeURIComponent(table)}` : base;

  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `qr-400gradi-${target}${table ? `-tavolo-${table}` : ""}.png`;
    a.click();
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-2 gap-10 items-center" data-testid="qr-page">
      <div className="space-y-6">
        <h1 className="font-serif text-5xl font-extrabold tracking-tight">QR Code</h1>
        <p className="text-muted-foreground">Stampa il QR sui tavoli o sui volantini: chi lo inquadra apre subito il menu o la pagina principale.</p>
        <div className="flex gap-2">
          {TARGETS.map(([k, l]) => (
            <button key={k} onClick={() => setTarget(k)} className={`rounded-full px-5 py-2 text-sm font-bold border ${target === k ? "bg-primary text-white border-primary" : "bg-white border-border"}`} data-testid={`qr-target-${k}`}>{l}</button>
          ))}
        </div>
        <div className="space-y-2">
          <Label htmlFor="qrt">Numero tavolo (facoltativo)</Label>
          <Input id="qrt" value={table} onChange={(e) => setTable(e.target.value.slice(0, 6))} placeholder="es. 5" className="h-12 bg-white max-w-[160px]" data-testid="qr-table-input" />
        </div>
        <p className="text-xs text-muted-foreground break-all" data-testid="qr-url">{url}</p>
      </div>
      <div className="rounded-[2rem] bg-white border border-border p-8 text-center">
        <div ref={ref} className="inline-block" data-testid="qr-canvas"><QRCodeCanvas value={url} size={240} fgColor="#1F1A17" includeMargin /></div>
        <p className="mt-3 font-serif text-2xl font-extrabold">{STORE_NAME}</p>
        <p className="text-sm text-muted-foreground">{table ? `Tavolo ${table} · ` : ""}Inquadra e ordina</p>
        <Button onClick={download} className="mt-6 rounded-full gap-2" data-testid="qr-download-button"><Download className="h-4 w-4" />Scarica PNG</Button>
      </div>
    </div>
  );
}
